import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {Model} from '../../../../../domain/model/common/model.class';
import {ActivatedRoute} from '@angular/router';
import {FormErrors} from '../../../../../components/forms/validation/form-validator.class';
import {StepScreenModel} from '../../../../shared/step/step-screen.component';
import {FileLocation, FileLocationFactory} from '../../../../../components/files/service/file-location.class';
import {AoaBoardSubspecialtyService} from '../../../../../domain/model/licenses-certifications/board/aoa/subspecialty/aoa-board-subspecialty.service';
import {AoaBoardSubspecialty} from '../../../../../domain/model/licenses-certifications/board/aoa/subspecialty/aoa-board-subspecialty.model';
import {AoaBoardSubspecialtyScreensManager} from './aoa-board-subspecialty-screens-manager.service';
import {AoaBoardService} from '../../../../../domain/model/licenses-certifications/board/aoa/aoa-board.service';
import moment = require('moment');
import ProjectionInformation = Model.ProjectionInformation;
import { VerificationService } from '../../../../../components/verification/service/verification.service';

@Component({
    template: require('./aoa-board-subspecialty-screen.component.html')
})
export class AoaBoardSubspecialtyScreenComponent {

    constructor(readonly modelService: AoaBoardSubspecialtyService,
                readonly aoaBoardService: AoaBoardService,
                readonly route: ActivatedRoute,
                readonly screensManager: AoaBoardSubspecialtyScreensManager,
                readonly fileLocationFactory: FileLocationFactory,
                readonly verificationService: VerificationService) {}

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    certifications: Array<string> = [
        'Addiction Medicine',
        'Adolescent & Young Adult Medicine',
        'Adolescent Medicine',
        'Adult and Pediatric Allergy and Immunology',
        'Angiography & Interventional Radiology',
        'Body Imaging',
        'Cardiology',
        'Child Neurology',
        'Child Psychiatry',
        'Clinical Cardiac Electrophysiology',
        'Correctional Medicine',
        'Critical Care',
        'Critical Care Medicine',
        'Cytopathology',
        'Dermatopathology',
        'Diagnostic Ultrasound',
        'Emergency Medical Services',
        'Endocrinology',
        'Female Pelvic Med/Reconstructive Surgery',
        'Forensic Pathology',
        'Gastroenterology',
        'Geriatric Medicine',
        'Geriatric Psychiatry',
        'Gynecologic Oncology',
        'Hand Surgery',
        'Hematology',
        'Hospice and Palliative Medicine',
        'Infectious Diseases',
        'Interventional Cardiology',
        'Maternal & Fetal Medicine',
        'Medical Toxicology',
        'MOHS Micrographic Surgery',
        'Neonatology',
        'Nephrology',
        'Neurology & Psychiatry',
        'Neurophysiology',
        'Neuroradiology',
        'Nuclear Radiology',
        'Occupational Medicine',
        'Oncology',
        'Otolaryngic Allergy',
        'Pain Management',
        'Pain Medicine',
        'Pediatric Anesthesiology',
        'Pediatric Dermatology',
        'Pediatric Endocrinology',
        'Pediatric Pulmonology',
        'Pediatric Radiology',
        'Pulmonary Diseases',
        'Radiation Therapy',
        'Reproductive Endocrinology',
        'Rheumatology',
        'Sleep Medicine',
        'Sports Medicine',
        'Surgical Critical Care',
        'Undersea and Hyperbaric Medicine',
        'Vascular & Interventional Radiology'
    ];

    certificationDateConstrains = {
        min: moment().subtract(100, 'year'),
        max: moment().add(5, 'year')
    };
    supportingDocumentFileLocation: FileLocation;

    get aoaIndex(): number {
        return +this.route.snapshot.params['aoaIndex'];
    }

    get index(): number {
        return +this.route.snapshot.params['index'];
    }

    aoaBoardCertificate?: string;

    stepScreenModel = new StepScreenModel<AoaBoardSubspecialty>({
        initialDataModel: new AoaBoardSubspecialty(),
        specificValidationMessages: {},
        screensManager: this.screensManager,
        _loadDataFn: () => {
            this.aoaBoardService.getCurrentUserModelEntry(this.aoaIndex).subscribe(abmsBoard => this.aoaBoardCertificate = abmsBoard!.certificate);
            this.supportingDocumentFileLocation = this.fileLocationFactory.create('aoaBoard', `currentUser/${this.aoaIndex}/sub/${this.index}`, new ProjectionInformation('supportingDocument'));
            this.verificationService.setUrl('aoaBoard', undefined, `${this.aoaIndex}/sub/${this.index}`);
            return this.modelService.getCurrentUserModelEntry(this.aoaIndex, this.index);
        },
        _submitDataFn: (model: AoaBoardSubspecialty) => {
            return this.modelService.updateCurrentUserModelEntry(this.aoaIndex, this.index, model);
        },
        _hasYesNoQuestion: () => this.modelService.doesCurrentUserModelEntryExist(this.aoaIndex, this.index).map(r => !r)
    });

    get model(): AoaBoardSubspecialty {
        return this.stepScreenModel.dataModel;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }

    handleCurrentlyCertifiedChange() {
        if (!this.model.currentlyCertified) this.model.certificationDate = undefined;
    }

    handleRecertifiedChange() {
        if (!this.model.recertified) this.model.recertificationDate = undefined;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/licenses-certifications/steps/board/aoa-subspecialty/aoa-board-subspecialty-screen.component.ts